<template>
  <action-dialog
    ref="alcoholAcknowledgementDialog"
    :class="$q.screen.gt.xs ? 'q-px-xl' : 'q-px-md'"
    :ok-label="$t('actions.confirm')"
    :cancel-label="$t('actions.cancel')"
    ok-color="positive"
    cancel-color="negative"
    ok-icon="fal fa-check"
    cancel-icon="fal fa-times"
    persistent
    buttons-inlined
    reverse-buttons-row
    label-capitalize
    data-test-id="alcohol-acknowledgement-dialog"
    @ok="handleAlcoholAcknowledgement()"
  >
    <template #custom-message>
      <div class="q-mx-lg text-center">
        <q-icon
          name="fal fa-id-card"
          class="q-my-lg"
          size="xl"
          color="primary"
        />
      </div>

      <div
        class="text-body1 text-center q-mb-sm"
        :class="$q.screen.gt.xs? 'q-mx-lg' : 'q-mx-md'"
      >
        {{ $t('acknowledgment.legalDrinkingAge') }}
      </div>
      <div
        class="text-body1 text-center"
        :class="$q.screen.gt.xs? 'q-mx-lg' : 'q-mx-md'"
      >
        {{ $t('acknowledgment.showIdPrompt') }}
      </div>
      <div
        class="q-my-md q-mx-md"
      >
        <q-checkbox
          v-model="dontAskAgain"
          color="primary"
          :label="$t('acknowledgment.dontAskAgain')"
        />
      </div>
    </template>
  </action-dialog>
</template>

<script>
import { Cookies } from 'quasar'
import ActionDialog from 'src/modules/consumer/components/ActionDialog'

export default {
  name: 'AlcoholAcknowledgementDialog',
  components: {
    ActionDialog
  },
  configuration: ['currentSite'],
  emits: ['alcohol-acknowledgement-concerned'],
  data () {
    return {
      dontAskAgain: false,
      shown: false
    }
  },
  methods: {
    show () {
      this.$refs.alcoholAcknowledgementDialog.show()
    },
    hide () {
      this.$refs.alcoholAcknowledgementDialog.hide()
    },
    handleAlcoholAcknowledgement () {
      // Set the cookie to not show the dialog again
      if (this.dontAskAgain) {
        Cookies.set(this.$constants.cookies.alcoholAcknowledgement, { siteId: this.currentSite.id, dontShowAgain: true, type: this.$constants.cookies.type.consumerConsent, expires: 1 })
      }
      this.$emit('alcohol-acknowledgement-concerned')
    }
  }
}
</script>
